// extracted by mini-css-extract-plugin
export default {"lineclamp":"Text--lineclamp--ZAdNZ","withDocsTooltip":"Text--withDocsTooltip--bxLUw","targetClass":"Text--targetClass--Mwmtp","icon":"Text--icon--MjOq-"};